import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const ISODetailFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default ISODetailFilter;